/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { INurse } from 'app/shared/model/nurse.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';
import { IRegimenDrug } from 'app/shared/model/regimen-drug.model';

export interface ITreatmentDrug {
  id?: string;
  administered?: boolean | null;
  administedDose?: string | null;
  administedDoseUnit?: string | null;
  administedDoseDilution?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  notes?: string | null;
  administeredDrug?: IMedicine | null;
  administeringNurse?: INurse | null;
  validatingNurse?: INurse | null;
  cycle?: ITreatmentCycle | null;
  regimenDrug?: IRegimenDrug | null;
}

export const defaultValue: Readonly<ITreatmentDrug> = {
  administered: false,
  active: false,
};
